import './SuggestionList.scss';

const SuggestionList = function (props) {
	if (! props.values?.original?.length) {
		return '';
	}
	const {values, fieldName, callback, selectedValue} = props;

	const suggestions = values.original.map((value, i) => {
		const input = value === selectedValue ? (
			<input type="radio" name={fieldName + '-suggestion'} value={value} onChange={() => {
				callback(fieldName, value);
				if (values.translated?.length) {
					callback(fieldName + 'Translated', values.translated[i]);
				}
			}} checked="checked" />
		) : (
			<input type="radio" name={fieldName + '-suggestion'} value={value} onChange={() => {
				callback(fieldName, value);
				if (values.translated?.length) {
					callback(fieldName + 'Translated', values.translated[i]);
				}
			}} />
		);
		const translation = values?.translated[i] ? (<><br /><em>{values?.translated[i]}</em></>) : '';
		return (
			<li className="suggestion" key={fieldName + i}><label>{input}<span>{value}{translation}</span></label></li>
		)
	});
	return (
		<ul className="suggestions">
			{suggestions}
		</ul>
	);
}

export default SuggestionList